var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","stroke":"#4a4a4a","strokeMiterlimit":"50","strokeWidth":"3","d":"M13.06 15.54a7.86 7.86 0 1 0 0-15.72 7.86 7.86 0 0 0 0 15.72z","key":0}),React.createElement("path",{"fill":"none","stroke":"#4a4a4a","strokeLinecap":"square","strokeMiterlimit":"50","strokeWidth":"3","d":"M13.222 15.628v9.883","key":1})]);
}

SearchIcon.defaultProps = {"width":"22","height":"35","viewBox":"0 0 25 23"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
